var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16C12.8765 16 16.5 12.3686 16.5 8C16.5 3.62353 12.8686 0 8.49216 0C4.12353 0 0.5 3.62353 0.5 8C0.5 12.3686 4.13137 16 8.5 16ZM8.5 14.6667C4.79804 14.6667 1.84118 11.702 1.84118 8C1.84118 4.29804 4.7902 1.33333 8.49216 1.33333C12.1941 1.33333 15.1588 4.29804 15.1667 8C15.1745 11.702 12.202 14.6667 8.5 14.6667ZM4.23333 6.4549H12.7824C13.1275 6.4549 13.3784 6.23529 13.3784 5.90588C13.3784 5.56863 13.1275 5.34902 12.7824 5.34902H4.23333C3.88039 5.34902 3.63725 5.56863 3.63725 5.90588C3.63725 6.23529 3.88039 6.4549 4.23333 6.4549ZM5.39412 9.05098H11.6216C11.9667 9.05098 12.2098 8.83137 12.2098 8.50196C12.2098 8.17255 11.9667 7.9451 11.6216 7.9451H5.39412C5.04118 7.9451 4.79804 8.17255 4.79804 8.50196C4.79804 8.83137 5.04118 9.05098 5.39412 9.05098ZM6.60196 11.6549H10.4059C10.751 11.6549 11.002 11.4353 11.002 11.1059C11.002 10.7686 10.751 10.549 10.4059 10.549H6.60196C6.25686 10.549 6.01373 10.7686 6.01373 11.1059C6.01373 11.4353 6.25686 11.6549 6.60196 11.6549Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Filter.f53e5b55115c6f6959e2b0858e64a34a.svg";